import { render, staticRenderFns } from "./AcceptInformationTab.vue?vue&type=template&id=1f0f8311&scoped=true&"
import script from "./AcceptInformationTab.vue?vue&type=script&lang=js&"
export * from "./AcceptInformationTab.vue?vue&type=script&lang=js&"
import style0 from "./AcceptInformationTab.vue?vue&type=style&index=0&id=1f0f8311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f8311",
  null
  
)

export default component.exports